import { useContext, useEffect, useState } from 'react';
import { DrawerContext } from '@CONTEXTS';
import DeliveryDetail from './detail';
import DeliveryTransactions from './transactions';

const useTabs = () => {
  const { data } = useContext(DrawerContext);
  const [state, setState] = useState([]);

  useEffect(() => {
    const tabs = [
      {
        title: 'Gönderi Detayı',
        component: <DeliveryDetail />,
      },
      {
        title: 'Gönderi Hareketleri',
        component: <DeliveryTransactions />,
      },
    ];

    setState(tabs);
  }, [data]);

  return state;
};

export default useTabs;
